import React from 'react';
import { Space, Table } from 'antd';
import {
  DashboardOutlined,
  HeartOutlined,
  SmileOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { GuuruOutlined } from '@guuru/react-icon';
import Guuru from './Guuru';
import Score from './Score';
import RowSeparator from '../RowSeparator';
import { LeaderboardRow } from '../hooks/useLeaderboard';

const responsiveColumnTypes = [
  { title: 'Profile', icon: UserOutlined },
  { title: 'Happiness', icon: SmileOutlined },
] as const;

const Style = { title: 'Style', icon: HeartOutlined } as const;

const ROW_SEPARATOR_ELEMENT_INDEX = 10;

const generateColumns = (isSmallDevice: boolean, showStyleColumn: boolean) => {
  const dynamicColumns = showStyleColumn
    ? [...responsiveColumnTypes, Style]
    : responsiveColumnTypes;

  const getOnCell = (index: number, column?: number) => {
    let colSpan = 1;
    if (column !== 0) {
      colSpan = index === ROW_SEPARATOR_ELEMENT_INDEX ? 0 : 1;
    } else if (index === ROW_SEPARATOR_ELEMENT_INDEX) {
      colSpan = isSmallDevice ? 2 : 2 + dynamicColumns.length;
    }
    return { colSpan };
  };

  const columns = [
    {
      title: <Space><GuuruOutlined />Guuru</Space>,
      dataIndex: 'expert',
      key: 'name',
      align: 'left',
      width: '60%',
      render: (_: unknown, record: LeaderboardRow, index: number) => (
        'node' in record
          ? <Guuru index={index} expert={record.node} />
          : <RowSeparator />),
      onCell: (_: LeaderboardRow, index?: number) => getOnCell(index || 0, 0),
    },
    ...dynamicColumns.map(({ title, icon: Icon }) => ({
      title: (
        <Space>
          <span style={{ fontWeight: 400 }}>
            {title}
          </span>
          <Icon />
        </Space>
      ),
      dataIndex: title.toLowerCase(),
      key: title.toLowerCase(),
      align: 'center',
      width: '10%',
      responsive: ['md'],
      render: (_: unknown, record: LeaderboardRow) => {
        if ('node' in record) {
          const { node } = record;
          const scores = node?.scores || {};
          return scores[title.toLowerCase() as keyof typeof scores] || 0;
        }
        return 0;
      },
      onCell: (_: LeaderboardRow, index?: number) => getOnCell(index || 0),
    })),
    {
      title: <Space>Score<DashboardOutlined /></Space>,
      dataIndex: 'score',
      key: 'score',
      align: 'center',
      render: (_: unknown, record: LeaderboardRow) => {
        if ('node' in record) {
          const { node } = record;
          const scores = node?.scores || {};
          return <Score score={scores.score || 0} fontSize={16} height={42} />;
        }
        return <Score score={0} fontSize={16} height={42} />;
      },
      onCell: (_: LeaderboardRow, index?: number) => getOnCell(index || 0),
    },
  ];

  return isSmallDevice ? [...columns, Table.EXPAND_COLUMN] : columns;
};

export default generateColumns;
